// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"28752823","453":"0b3d9fcd","732":"57874b7c","977":"a1f942c1"}[chunkId] + ".chunk.js";
};